import { render, staticRenderFns } from "./BatchQueryList.vue?vue&type=template&id=1b59821d&scoped=true&"
import script from "./BatchQueryList.vue?vue&type=script&lang=js&"
export * from "./BatchQueryList.vue?vue&type=script&lang=js&"
import style0 from "./BatchQueryList.vue?vue&type=style&index=0&id=1b59821d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59821d",
  null
  
)

export default component.exports